export const model = {
    fields: {
        firstname: {
            isRequired: true
        },
        lastname: {
            isRequired: true
        },
        email: {
            isRequired: true,
            type: 'email'
        },
        sellerId: {
            isRequired: true
        },
        login: {
            isRequired: true
        }
    }
}